import { render, staticRenderFns } from "./ProjectLocations.vue?vue&type=template&id=452a41bb&scoped=true&"
import script from "./ProjectLocations.vue?vue&type=script&lang=js&"
export * from "./ProjectLocations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLocations.vue?vue&type=style&index=0&id=452a41bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a41bb",
  null
  
)

export default component.exports